
import DataErrorPage from '../../../../../../Components/DataErrorPage/DataErrorPage';

const EmptyFilteredComponent: React.FC<React.PropsWithChildren<{}>> = props => (
  <DataErrorPage
    errorText="Ingen data med nuvarande urval och filter"
    icon="filter_search"
  />
);

export default EmptyFilteredComponent;
